export const DEV = {
  projectId: 'rundown-app-641e0',
  marketingBase: 'https://rundown-studio-marketing-dev.web.app',
}

export const PROD = {
  projectId: 'rundown-studio-46e96',
  marketingBase: 'https://rundownstudio.app',
}

export const LOCAL = {
  marketingBase: 'http://localhost:4321',
}

export type MarketingLinks = {
  pricing: string
  docs: string
  terms: string
  privacy: string
}

export type Environment = {
  name: 'prod' | 'dev' | 'local'
  marketingBase: string
  marketingLinks: MarketingLinks
}

function buildMarketingLinks(marketingBase: string): MarketingLinks {
  return {
    pricing: `${marketingBase}#pricing`,
    docs: `${marketingBase}/docs`,
    terms: `${marketingBase}/terms-of-service`,
    privacy: `${marketingBase}/privacy-policy`,
  }
}

function buildEnvironment(name: Environment['name'], marketingBase: string): Environment {
  return { name, marketingBase, marketingLinks: buildMarketingLinks(marketingBase) }
}

/**
 * Pick the environment from callers own runtime (`import.meta.env`, `process.env` etc).
 * Needed because code in `/shared` cannot access the env.
 *
 * @remarks
 *   - Prod wins over `isLocal`, so a local flag can never leak into a prod build.
 *   - Unknown or missing `projectId` resolves to dev.
 */
export function resolveEnvironment({
  projectId,
  isLocal = false,
}: {
  projectId?: string
  isLocal?: boolean
}): Environment {
  if (projectId === PROD.projectId) return buildEnvironment('prod', PROD.marketingBase)
  if (isLocal) return buildEnvironment('local', LOCAL.marketingBase)
  return buildEnvironment('dev', DEV.marketingBase)
}
